import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class FireAndFlowerPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Arial.ExtraBold_800];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/tof6ywr.css';
  }
}
